const DEFAULT_CDN_DOMAINS = [
    'a.storyblok.com',
    'a2.storyblok.com',
    'int.storyblok.cdn.vmo2digital.co.uk',
    'storyblok.cdn.vmo2digital.co.uk',
];
const CDN_DOMAIN = process.env.CDN_DOMAIN;
export const StoryblokImageLoader = ({ src, width, quality = 75, }) => {
    try {
        const url = new URL(src);
        if (!DEFAULT_CDN_DOMAINS.includes(url.hostname)) {
            return url.toString();
        }
        if (CDN_DOMAIN) {
            url.hostname = CDN_DOMAIN;
        }
        return `${url}/m/${width}x0/filters:quality(${quality})`;
    }
    catch (e) {
        return src;
    }
};
export default StoryblokImageLoader;
